// Pages
import Push from '../Push';

// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, Avatar, Badge, Cell, IconButton, Navigation, Section } from '@telegram-apps/telegram-ui';

// Icons
import { ReactComponent as PostsIcon } from "../assets/posts.svg";
import { ReactComponent as PostingIcon } from "../assets/posting.svg";
import { ReactComponent as ModeIcon } from "../assets/mode.svg";
import { ReactComponent as StreamsIcon } from "../assets/streams.svg";
import { ReactComponent as StreamsOutlineIcon } from "../assets/streams_outline.svg";
import { ReactComponent as PlanIcon } from "../assets/plan.svg";
import { ReactComponent as FilterIcon } from "../assets/filter.svg";
import { ReactComponent as SourcesIcon } from "../assets/sources.svg";
import { ReactComponent as StyleIcon } from "../assets/style.svg";
import { ReactComponent as TimersIcon } from "../assets/timers.svg";
import { ReactComponent as OtherIcon } from "../assets/other.svg";

const tg = window.Telegram.WebApp;

const PushPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, activeView, setActiveView, premodePosts }) => {
    const filteredPosts = premodePosts.filter(post => selectedGroup === null || post.id === selectedGroup.id);

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'streams') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Section className='sectionChannel'>
                    <Cell
                        className='streamsIcon'
                        hovered={false}
                        before={<Avatar size={48} src={avatarSrc} acronym={selectedGroup.name.substring(0, 2)} />}
                        after={<IconButton mode="gray" size="l"><StreamsOutlineIcon className='SettingsItemIcon' /></IconButton>}
                        subtitle={`${selectedGroup.members_count} подписчиков нахуй`}
                    >
                        {selectedGroup.name}
                    </Cell>
                    <Cell
                        onClick={() => setActivePanel('channel')}
                        className="settingsItem"
                        before={<PostingIcon className='SettingsItemIcon' />}
                        after={<Navigation>{selectedGroup.active ? "Включен" : "Выключен"}<Badge style={{ background: selectedGroup.active ? "#4bb34b" : "" }} type="dot" /></Navigation>
                        }
                    >
                        Постинг
                    </Cell>
                    <Cell className='settingsItem' before={<ModeIcon className='SettingsItemIcon' />} after={<Navigation>Премодерация</Navigation>}>Режим</Cell>
                    <Cell className='settingsItem postsItem' before={<PostsIcon className='SettingsItemIcon' />} after={<Navigation>{<Badge type="number">{filteredPosts.length}</Badge>}</Navigation>}>Публикации</Cell>
                </Section>
                <Section className='sectionChannel' header="Управление">
                    <Cell className='settingsItem' before={<StreamsIcon className='SettingsItemIcon' />} after={<Navigation />}>Рубрики</Cell>
                    <Cell className='settingsItem soonItem' before={<PlanIcon className='SettingsItemIcon' />} after={<Navigation><Badge type="number">СКОРО</Badge></Navigation>}>Контент-план</Cell>
                </Section>
                <Section className='sectionChannel' header="Параметры публикации">
                    <Cell className='settingsItem' before={<SourcesIcon className='SettingsItemIcon' />} after={<Navigation />}>Источники</Cell>
                    <Cell className='settingsItem' before={<FilterIcon className='SettingsItemIcon' />} after={<Navigation />}>Фильтрация</Cell>
                    <Cell className='settingsItem' before={<StyleIcon className='SettingsItemIcon' />} after={<Navigation />}>Стиль публикации</Cell>
                    <Cell className='settingsItem' before={<TimersIcon className='SettingsItemIcon' />} after={<Navigation />}>Расписание</Cell>
                </Section>
                <Section className='sectionChannel' header="Остальное">
                    <Cell className='settingsItem' before={<OtherIcon className='SettingsItemIcon' />} after={<Navigation />}>Дополнительно</Cell>
                </Section>
            </AppRoot>
        </div>
    );
};

export default PushPage;